/**
 * Talep/yanıt gövdesini hazırlar. İki taşıma yolu tek yerde birleşir:
 * - dosya seçiciden gelen ekler multipart alanı (`attachments`) olarak,
 * - panodan yapıştırılan görseller base64 alanı (`pastedImages`) olarak gider.
 *
 * Dosya yoksa gövde JSON kalır (mevcut davranış korunur); yapıştırılan görsel
 * JSON'da da form-data'da da aynı alan adıyla taşınır, sunucu ikisini de aynı
 * doğrulama hattından geçirir.
 *
 * @param values       gövde alanları (ör. { message } veya { subject, message, ... })
 * @param files        multipart dosyalar
 * @param pastedImages data URI biçiminde yapıştırılmış görseller
 */
export const buildMessagePayload = (values, files = [], pastedImages = []) => {
    if (files.length === 0) {
        return pastedImages.length === 0 ? values : { ...values, pastedImages };
    }

    const payload = new FormData();
    Object.entries(values).forEach(([key, value]) => payload.append(key, value));
    files.forEach(file => payload.append("attachments", file));
    pastedImages.forEach(dataUri => payload.append("pastedImages", dataUri));
    return payload;
};
